/**
 * Ключ отрисовки миниатюры блока в ленте. Новый блок сначала стоит временной
 * записью (отрицательный id), потом её сменяет настоящий блок с другим id.
 * Если ключ — id, React пересоздаёт миниатюру, и анимация появления
 * (`animate-thumb-in`) обрывается рывком. Поэтому настоящий блок наследует
 * ключ временной записи: тот же узел, анимация доходит до конца.
 *
 * Модульная карта, а не стор: это не данные, а склейка для отрисовки,
 * переживать перезагрузку ей незачем.
 */
const keys = new Map<number, number>()

/** Склейка нужна только на время анимации: потом ключ возвращается к id,
 *  иначе при повторном открытии урока блок снова «выезжал» бы. */
const KEEP_MS = 1500

export const rememberRenderKey = (realId: number, tempId: number): void => {
  keys.set(realId, tempId)
  setTimeout(() => keys.delete(realId), KEEP_MS)
}

export const renderKeyOf = (id: number): number => keys.get(id) ?? id
